module["exports"] = [
  "Italia"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/default_country.js
 ** module id = 683
 ** module chunks = 0
 **/